import React, { useState, useEffect } from 'react';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import './Streamy.scss';
import coverImg from '../../assets/images/streamy__cover.png';
import designProcessImg from '../../assets/images/streamy__design-process.png';
import designProcessMobImg from '../../assets/images/streamy__design-process_mob.png';
import jobStoriesImg from '../../assets/images/streamy__job-stories.png';
import userPathImg from '../../assets/images/streamy__user-path1.png';
import wireframesImg from '../../assets/images/streamy__wireframes1.png';
import branIdentityImg from '../../assets/images/streamy__brand-identity.png';
import uiImg from '../../assets/images/streamy__ui.png';
import uiMobImg from '../../assets/images/streamy__ui_mob.png';
import presentationImg from '../../assets/images/streamy__presentation.png';
import flow1 from '../../assets/images/flow__1.png';
import flow2 from '../../assets/images/flow__2.png';
import flow3 from '../../assets/images/flow__3.png';
import FadeInSection from '../../components/FadeInSection';
import SkeletonPage from '../../components/SkeletonPage/SkeletonPage';

const Streamy = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  React.useEffect(() => {
    // Создаем объект Image для предварительной загрузки
    const img = new Image();
    img.src = coverImg; // Укажите URL изображения

    // Устанавливаем слушатель загрузки для обновления состояния
    img.onload = () => {
      setIsImageLoaded(true);
    };

    // Обработка ошибки (если изображение не загружается)
    img.onerror = () => {
      console.error('Ошибка загрузки изображения');
      setIsImageLoaded(true); // Загрузить страницу, даже если изображение не загрузилось
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {!isImageLoaded && <SkeletonPage />}
      {isImageLoaded && (
        <section className="streamy case">
          <ProgressBar />
          <FadeInSection>
            <h1 className="case__title">
              When applying for a job at Paradox Security, I received a Home task and, as part of
              it, I created billing pages for a fictitious mobile application of the
              <span className="case__title-span"> streaming service Streamy</span>
            </h1>{' '}
          </FadeInSection>
          <div className="case__content">
            <FadeInSection>
              <img className="case__content-image" src={coverImg} alt="screen" />
            </FadeInSection>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Task</h3>
                  <p>
                    To design <span>a flow of selecting and paying for a suitable plan</span> for
                    the streaming service Streamy with basic plan and 2 extensions: VOD plan and
                    24/7 online support
                  </p>{' '}
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">Vision</h3>
                  <p>
                    I wanted to design a{' '}
                    <span>user-friendly flow with the ability to compare different options.</span> I
                    wanted to help the user to select the most profitable plan
                  </p>
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">Scope of work</h3>
                  <p>
                    I divided the project into four parts and formed a list of tasks in each
                    direction
                  </p>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={screenWidth > 853 ? designProcessImg : designProcessMobImg}
                    alt="design process"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Benchmarking & References</h3>
                  <div>
                    <p>
                      First of all, I found and analyzed the market leaders in this area (Disney+,
                      Paramount+, Netflix, Hulu & HBO Max) and some other applications. Found good
                      examples to look at
                    </p>
                    <p>
                      I also collected several references that I was guided by in the process of
                      work
                    </p>
                  </div>
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">User Research</h3>
                  <div>
                    <p>
                      I conducted an in-depth interview with one user. It is not
                      correct for a real project, but as part of a home task, it allowed me to
                      understand user needs, get direction, and test the results
                    </p>
                    <p>
                      The analysis allowed me to understand the user's problems, to find out what
                      user is guided by when making decisions, what is important to him
                    </p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={jobStoriesImg}
                    alt="job stroies"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">User's path</h3>
                  <div>
                    <p>
                      I created the scenario of the user's path in order to understand how to make
                      it as comfortable as possible
                    </p>
                  </div>{' '}
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={userPathImg} alt="user path" />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Wireframes & User Testing</h3>
                  <div>
                    <p>
                      In the process of my work, I designed several screen options to determine the
                      most successful one
                    </p>
                    <p>
                      I tested the sequence of steps with my respondent. No downsides were found in
                      the flow. Once again, I emphasize that data from one respondent would be
                      subjective and not representative of a real product
                    </p>
                  </div>{' '}
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={wireframesImg}
                    alt="wireframes"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Brand Identity</h3>
                  <div>
                    <p>
                      Since I didn't have any brand data,
                      <br /> I relied on two AI services to assist me in creating a brand identity,
                      selecting colors, and generating ideas for a logo
                    </p>
                  </div>{' '}
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={branIdentityImg}
                    alt="bran identity"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">User Interface</h3>
                  <div>
                    <p>
                      I have prepared a UI kit in which I have collected colors, fonts, and
                      components
                    </p>
                    <p>
                      It's allowed me to speed up the work process and maintain the consistency of
                      the project
                    </p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={screenWidth > 853 ? uiImg : uiMobImg}
                    alt="ui"
                  />
                </FadeInSection>
              </div>
            </div>
            <FadeInSection>
              <h2 className="case__title streamy__title">
                Based on the results of respondents' research,{' '}
                <span className="case__title-span">
                  I had to change primary requirements to complete the task.
                </span>{' '}
                I decided to offer VOD content not as additional option but as a main part of basic
                plan for users’ convenience
              </h2>
            </FadeInSection>
            <div className="flow">
              <FadeInSection>
                <div className="flow-cnt">
                  <img
                    className="text-and-image__single-img text-and-image__single-img_flow"
                    src={flow1}
                    alt="flow 1"
                  />
                </div>
              </FadeInSection>
              <FadeInSection>
                <div className="flow-cnt">
                  <img
                    className="text-and-image__single-img text-and-image__single-img_flow"
                    src={flow2}
                    alt="flow 2"
                  />
                </div>
              </FadeInSection>
              <FadeInSection>
                <img
                  className="text-and-image__single-img text-and-image__single-img_flow"
                  src={flow3}
                  alt="flow 3"
                />
              </FadeInSection>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Presentation</h3>
                  <div>
                    <p>
                      It is important not only to create solutions, but also to present them
                      competently. To complete the Home Task, I prepared a presentation and a link
                      to all the artifacts
                    </p>
                  </div>{' '}
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={presentationImg}
                    alt="presentation"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Reflection</h3>
                  <div>
                    <p>
                      First of all, I would like to remind all colleagues{' '}
                      <span>not to be afraid to deviate from the rules and the original task</span>{' '}
                      if this will help solve the problem better and improve our metrics
                    </p>
                    <p>
                      And <span>always do your best,</span> even if it is a training or test project
                    </p>
                    <p>
                      Completing this home task allowed me to get a position as a Product Designer
                      at Paradox Security
                    </p>
                  </div>
                </FadeInSection>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Streamy;
